import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nocode/nocode_production/frontend/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/nocode/nocode_production/frontend/src/app/[locale]/(application)/(main)/apps/submit-app/AppSubmitForm.tsx");
